import React from "react";
import { makeStyles, createStyles, Button } from "@material-ui/core";
import PropTypes from "prop-types";
import { Add } from "@material-ui/icons";

const useStyles = makeStyles((theme) =>
  createStyles({
    contactsHeaderContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderBottom: "0.5px solid #DEDEDE",
      padding: "0px 0px 5px 0px",
    },
    contactsHeader: {
      fontFamily: theme.typography.secondary,
      fontWeight: "700",
      fontSize: "36px",
      color: "#4E4E4E",
      margin: "0px",
    },
    lessWeight: {
      fontWeight: "600",
    },
    addContactButtonContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "9px 20px",
      background: "#F5F5F5",
      borderRadius: "10px",
      boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.15)",
      cursor: "pointer",
      marginBottom: "25px",
    },
    addContactButtonLabel: {
      fontFamily: theme.typography.secondary,
      fontWeight: "700",
      fontSize: "16px",
      color: "#333",
      margin: "0px 16px 0px 0px",
    },
    addContactButtonIcon: {
      color: "#fff",
      fontSize: "24px",
    },
    editContactButton: {
      background: theme.palette.areaPulseBlue,
      minWidth: "0px",
      padding: "8px",
      borderRadius: "10px",
      boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.45)",
      "&:hover": {
        background: theme.palette.areaPulseBlue,
      },
    },
    editContactButtonIcon: {
      color: "#fff",
      fontSize: "24px",
    },
  })
);

const ContactsHeader = ({ createContactOpen, setCreateContactOpen }) => {
  const classes = useStyles();

  const handleClickOpen = () => {
    setCreateContactOpen({ open: true, editing: false, editPayload: {} });
  };

  return (
    <div className={classes.contactsHeaderContainer}>
      <h1 className={classes.contactsHeader}>Contacts</h1>
      <div className={classes.addContactButtonContainer}>
        <h1 className={classes.addContactButtonLabel}>
          Add New <br />
          Contact
        </h1>
        <div>
          <Button className={classes.editContactButton} onClick={handleClickOpen}>
            <Add color="inherit" fontSize="inherit" className={classes.editContactButtonIcon} />
          </Button>
        </div>
      </div>
    </div>
  );
};

ContactsHeader.propTypes = {
  createContactOpen: PropTypes.object,
  setCreateContactOpen: PropTypes.func,
};

export default ContactsHeader;
